// Module
import routes from './routes';
import deviceStateFilter from './state.filter';

export default angular.module('app.main.panel.module.new_device_status', [])
	.config(routes)
	.filter('devstate', deviceStateFilter)
	.name;



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/new_devices_status/index.js
 **/